import Notice from '@/components/common/Notice'
import CustomModal from '@/components/ui/ui-react-antd/Modal/CustomModal'
import Button from '@/components/ui/ui-react-antd/MyButton/Button'
import AuthService from '@/shared/services/AuthService'
import { getRegexPassword } from '@/shared/utils/stringsUtils'
import { Col, Form, Input, Row } from 'antd'
import { useState } from 'react'

const VerifyForgetModal = ({ openVerifyModal, handleCancel, handleLogin, email }: any) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const verifyOTP = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()
      const res = await AuthService.forgotPassword({
        code: values.otp,
        email: email,
        newPassword: values.newPassword,
      })

      if (res.isError || !res.isOk) {
        Notice({
          isSuccess: false,
          msg: res.object || 'Mã xác minh không đúng hoặc có lỗi xảy ra!',
        })
        return
      }
      Notice({
        isSuccess: true,
        msg: 'Đặt lại mật khẩu thành công!',
      })

      handleCancel()
      handleLogin()
    } catch (_error: any) {
      console.error('Error verifying OTP:', _error)
      // Bỏ qua nếu là lỗi validate form (hiển thị inline)
      if (_error?.errorFields) return
      // Bỏ qua nếu là lỗi API đã được Axios Interceptor xử lý (có notify.error)
      if (_error?.errorCode || _error?.errorMessage || _error?.response) return

      Notice({
        isSuccess: false,
        msg: 'Có lỗi xảy ra khi xác minh OTP. Vui lòng thử lại.',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <CustomModal
      title="Thay Đổi Mật Khẩu"
      width="600px"
      footer={null}
      open={openVerifyModal}
      onCancel={handleCancel}
    >
      <div style={{ padding: '20px 0' }}>
        <div
          style={{
            padding: '16px',
            marginBottom: '24px',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
            Mã xác thực đã được gửi qua mail của bạn.
          </div>
          <div style={{ fontSize: '14px', color: '#666' }}>
            Vui lòng kiểm tra để biết mã xác thực
          </div>
        </div>

        <Form form={form} layout="vertical">
          <Form.Item
            label="Nhập mã xác thực"
            name="otp"
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập mã xác minh!',
              },
            ]}
            style={{ marginBottom: '20px' }}
          >
            <Input
              placeholder="Nhập mã xác thực của bạn"
              size="large"
              style={{
                height: '50px',
                borderRadius: '8px',
                fontSize: '16px',
              }}
            />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập mật khẩu mới!',
              },
              {
                pattern: getRegexPassword(),
                message:
                  'Mật khẩu có chứa ít nhất 8 ký tự, trong đó có ít nhất một số và bao gồm cả chữ thường và chữ hoa và ký tự đặc biệt, ví dụ @, #, ?, !.',
              },
            ]}
            label="Nhập mật khẩu mới"
            name="newPassword"
            style={{ marginBottom: '20px' }}
          >
            <Input.Password
              placeholder="Mật khẩu mới"
              size="large"
              style={{
                height: '50px',
                borderRadius: '8px',
                fontSize: '16px',
              }}
            />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập lại mật khẩu mới!',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error('Mật khẩu nhập lại phải giống với mật khẩu mới!'))
                },
              }),
            ]}
            label="Nhập lại mật khẩu mới"
            name="confirmPassword"
            style={{ marginBottom: '24px' }}
          >
            <Input.Password
              placeholder="Xác nhận mật khẩu mới"
              size="large"
              style={{
                height: '50px',
                borderRadius: '8px',
                fontSize: '16px',
              }}
            />
          </Form.Item>
        </Form>

        <Row gutter={16}>
          <Col span={12}>
            <Button
              type="default"
              onClick={() => {
                handleLogin()
                handleCancel()
              }}
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500',
              }}
            >
              Quay lại
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={loading}
              type="default"
              htmlType="submit"
              onClick={() => {
                verifyOTP()
              }}
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500',
              }}
            >
              Xác nhận
            </Button>
          </Col>
        </Row>
      </div>
    </CustomModal>
  )
}

export default VerifyForgetModal
